/** @format */
import React, { useEffect, useState } from "react";
import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  CircleMarker,
} from "react-leaflet";
import L from "leaflet";
import axios from "axios";
import "leaflet/dist/leaflet.css";
import Accessiblity from "../Accessiblity/Accessibility";
import shadowmask from "../../Data/shadowmask.json";
import sunPath from "../../Data/sunpath_new1.json";

// Fix Leaflet default marker issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
  iconUrl: require("leaflet/dist/images/marker-icon.png"),
  shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
});

export default function MapPage() {
  const [selectedKey, setSelectedKey] = useState("mar");
  const [weather, setWeather] = useState(null);
  const lat = 8.80556; // Thoothukudi
  const lon = 78.145;

  // Fetch realtime weather
  useEffect(() => {
    const fetchWeather = async () => {
      try {
        const res = await axios.get(
          `https://api.open-meteo.com/v1/forecast?latitude=${lat}&longitude=${lon}&current_weather=true`
        );
        setWeather(res.data.current_weather);
      } catch (err) {
        console.error("Weather fetch failed:", err);
      }
    };
    fetchWeather();
  }, []);
  // const timestamp = new Date(weather.time);
  // console.log(timestamp);
  return (
    <div
      style={{
        height: "calc(88vh - 20px)",
        width: "100%",
        background: "linear-gradient(135deg, #6e8efb, #a777e3)",
        padding: "10px",
        borderRadius: "12px",
        boxShadow: "0 4px 20px rgba(0,0,0,0.2)",
      }}>
        <Accessiblity/>
      {/* Month selector */}
      <select
        value={selectedKey}
        onChange={(e) => setSelectedKey(e.target.value)}>
        <option value="mar">March</option>
        <option value="jun">June</option>
        <option value="sep">September</option>
        <option value="dec">December</option>
        <option value="07 Aug">07 Aug</option>
        <option value="dayLength">Day Length</option>
      </select>
      <MapContainer
        center={[lat, lon]}
        zoom={12}
        style={{
          height: "100%",
          width: "100%",
          borderRadius: "12px",
          overflow: "hidden",
        }}>
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />

        {/* Weather Marker */}
        {weather && (
          <Marker position={[lat, lon]}>
            <Popup>
              <b>🌤 Current Weather</b> <br />
              Temp: {weather.temperature}°C <br />
              Wind: {weather.windspeed} km/h <br />
              TimeStamp: {Date(weather.time)}
            </Popup>
          </Marker>
        )}

        {/* Shadow Mask polygons
        {shadowmask.features &&
          shadowmask.features.map((feature, index) => {
            const coords =
              feature.geometry.type === "Polygon"
                ? [feature.geometry.coordinates[0]]
                : feature.geometry.type === "MultiPolygon"
                ? feature.geometry.coordinates.map((poly) => poly[0])
                : [];
            return coords.map((poly, idx) => (
              <Polygon
                key={`${index}-${idx}`}
                positions={poly.map(([lng, lat]) => [lat, lng])}
                color="purple"
                fillOpacity={0.3}
              />
            ));
          })} */}
        {/* Shadowmask points */}
        {Array.isArray(shadowmask[0]) &&
          shadowmask[0].map((coord, idx) =>
            Array.isArray(coord) && coord.length >= 2 ? (
              <CircleMarker
                key={`shadow-${idx}`}
                center={[coord[0], coord[1]]}
                pathOptions={{ color: "gray" }}
                radius={1}
              />
            ) : null
          )}
        {/* Sun Path lines
        {sunPath.features &&
          sunPath.features.map((feature, index) => {
            if (feature.geometry.type === "LineString") {
              return (
                <Polyline
                  key={index}
                  positions={feature.geometry.coordinates.map(([lng, lat]) => [
                    lat,
                    lng,
                  ])}
                  color="orange"
                  weight={3}
                />
              );
            }
            return null;
          })} */}

        {/* Sunpath points */}
        {sunPath[selectedKey] &&
          Array.isArray(sunPath[selectedKey]) &&
          sunPath[selectedKey].map((point, idx) =>
            Array.isArray(point) && point.length >= 2 ? (
              <CircleMarker
                key={`sun-${idx}`}
                center={[point[0], point[1]]}
                pathOptions={{ color: "orange" }}
                radius={2}
              />
            ) : null
          )}
      </MapContainer>
    </div>
  );
}
